export default "__VITE_ASSET__b8dd1bca__"